<template>
  <div class="division-details-container">
    <p class="division-title">
      <b>{{ division.name }}</b>
    </p>
    <p class="section-title registration-fee">
      <b>Registration fee:</b>
      <template v-if="division.registrationFee">
        {{ division.registrationFee.formatted }}</template
      ><template v-else> Free</template>
    </p>

    <p class="section-title tour-pass-title">
      <b>Tour pass:</b>
      <template v-if="division.tourPasses.length > 0">
        Tour pass available for this division</template
      ><template v-else> Unavailable for this division</template>
    </p>
    <p class="section-copy tour-pass-copy">
      If you purchase a tour pass you can register for upcoming events in this
      tour without paying again.
    </p>
    <template v-if="division.minRating">
      <p class="section-title">
        <b>Minimum PDGA rating:</b>
        {{ division.minRating }}
      </p>
      <p class="section-copy">The minimum PDGA rating for this division.</p>
    </template>
    <template v-if="division.maxRating">
      <p class="section-title">
        <b>Maximum PDGA rating:</b>
        {{ division.maxRating }}
      </p>
      <p class="section-copy">The maximum PDGA rating for this division.</p>
    </template>
    <p class="section-title">
      <b>Maximum spots:</b>
      <template v-if="division.maxSpots !== null">
        {{ division.maxSpots }}</template
      ><template v-else> Unlimited</template>
    </p>
    <p class="section-copy">The number of available spots.</p>

    <p class="section-title">
      <b>Reserved spots:</b>
      <template v-if="division.reservedSpots !== null">
        {{ division.reservedSpots }}</template
      ><template v-else> Unlimited</template>
    </p>
    <p class="section-copy">The number of reserved spots.</p>

    <p class="section-title">
      <b>Maximum registrations:</b>
      <template v-if="division.maxRegistrations !== null">
        {{ division.maxRegistrations }}</template
      ><template v-else> Unlimited</template>
    </p>
    <p class="section-copy">
      The total number of combined players that can be confirmed and be on the
      waiting list.
    </p>

    <p class="stages-title" v-if="divisionStages.length > 0">
      <b>Stages ({{ divisionStages.length }}):</b>
    </p>
    <div class="stage" v-for="(stage, index) in divisionStages">
      <p class="stage-title">
        <b>Stage {{ index + 1 }}</b>
      </p>
      <p class="stage-date">
        {{ dateFormatter(stage.date, 'D MMMM YYYY, HH:mm') }}
      </p>
      <p class="stage-criteria">{{ formattedStage(stage) }}</p>
    </div>
  </div>
</template>

<script>
import dateFormats from '@/mixins/dateFormats.js'

export default {
  name: 'DivisionDetailsPopup',
  mixins: [dateFormats],
  props: {
    division: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    divisionStages() {
      return this.stages.filter(
        (stage) => stage.division.id === this.division.id
      )
    },
  },
  methods: {
    formattedStage(stage) {
      if (stage.criterias.length === 1) {
        const criterion = stage.criterias[0]

        if (criterion.type === 'PDGA_NUMBER') {
          return 'Active PDGA member'
        }

        if (criterion.type === 'OPEN_FOR_ALL') {
          return 'Open for all'
        }

        if (criterion.type === 'MAX_PDGA_RATING') {
          return 'Max PDGA rating: ' + criterion.value
        }

        if (criterion.type === 'MIN_PDGA_RATING') {
          return 'Min PDGA rating: ' + criterion.value
        }
      }
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.division-details-container {
  padding: 0 32px 32px 32px;
  max-width: 700px;
}

.stages-title {
  margin: 16px 0 0 0;
  font-size: 1.125rem;
}

.stage {
  padding: 16px 0;
  border-bottom: 1px solid $fog;

  p {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}

.division-title {
  font-size: 1.125rem;
  padding-bottom: 20px;
}

.registration-fee {
  padding-bottom: 16px;
  border-bottom: 1px solid $fog;
}

.section-title {
  font-size: 1rem;
  padding-top: 16px;
  border-top: 1px solid $fog;
}

.section-copy {
  margin-top: 8px;
  font-size: 1rem;
  color: $strom;
  padding-bottom: 16px;
  border-bottom: 1px solid $fog;
  line-height: 1.5rem;
}

@import '@/styles/Typography';
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
}
</style>
